import type { ReactNode } from 'react';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { lightTheme } from '../theme';

const globalStyles = {
  a: {
    textDecoration: 'none',
    color: 'inherit',
  },
  img: {
    maxWidth: '100%',
    display: 'block',
  },
};

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <MUIThemeProvider theme={lightTheme}>
      <CssBaseline />
      <GlobalStyles styles={globalStyles} />
      {children}
    </MUIThemeProvider>
  );
}
